(function ($) {
    "use strict";

    $(function () {
        $.formatNumber = function formatNumber(num, isFloat) {
            let formattedNumber;
            if (!isFloat) {
                formattedNumber = Math.round(num);
            } else {
                // Removes trailing zeros and a trailing comma if it's a float
                formattedNumber = parseFloat(num.toFixed(2));
            }
            // Format number with space as thousand separator
            return new Intl.NumberFormat('hu-HU').format(formattedNumber);
        }

        $.animateCounter = function animateCounter(counter, targetValue, duration) {
            let startTime = null;
            const isFloat = Math.floor(targetValue) !== targetValue;

            function step(timestamp) {
                if (!startTime) startTime = timestamp;
                const progress = timestamp - startTime;
                const now = Math.min(progress / duration, 1) * targetValue;

                counter.textContent = $.formatNumber(now, isFloat);

                if (progress < duration) {
                    requestAnimationFrame(step);
                }
            }

            requestAnimationFrame(step);
        }



    });
})(jQuery);




